import Typing from './Typing';

export default Typing;
export Backspace from './Backspace';
export Cursor from './Cursor';
export Delay from './Delay';
export Reset from './Reset';
export Speed from './Speed';



// WEBPACK FOOTER //
// ./src/components/Typewriter/index.js